// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gHyoKzWr-vSslXo7H1-XS","delete":"_1KjylkKASxYbpxAg4Ho6Ql","contactlist":"_3dSFg6WBcWAvboHI14rSqj"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/FaceSigners/styles.css
// module id = 2905
// module chunks = 0